
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.65 0a4.55 4.55 0 00-4.539 4.537c0 1.548.836 2.854 2.028 3.673-1.837.86-3.145 2.616-3.145 4.712v4.336c0 .409.331.74.74.74h4.727l.01.002h9.795a.74.74 0 00.74-.74v-4.336c0-2.088-1.3-3.836-3.127-4.7 1.202-.818 2.045-2.129 2.045-3.685A4.548 4.548 0 0011.387.002c-.868 0-1.676.25-2.367.676A4.5 4.5 0 006.65 0zm0 1.478c.423 0 .827.086 1.192.239a4.507 4.507 0 00-.994 2.822c0 1.076.404 2.032 1.05 2.792a3.07 3.07 0 01-1.248.264 3.048 3.048 0 01-3.058-3.058A3.048 3.048 0 016.65 1.478zm4.737.002a3.046 3.046 0 013.056 3.059 3.046 3.046 0 01-3.056 3.058c-2.326 0-3.037-1.502-3.059-3.058a3.058 3.058 0 013.059-3.059zM6.568 9.104h.127a4.5 4.5 0 01.742.065c-1.043.947-1.707 2.264-1.707 3.755v3.596H2.475v-3.598c0-2.102 1.79-3.818 4.093-3.818zm4.737.002h.127c2.304 0 4.095 1.716 4.095 3.818v3.598c-4.413.002.492-.002-8.316-.002v-3.596c0-1.315.732-2.436 1.79-3.167 1.059-.731 2.05-.65 2.304-.65z","font-family":"sans-serif","overflow":"visible","paint-order":"stroke fill markers"}})])
          )
        }
      }
    